import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import {
  ArrowUpRight,
  Flame,
  Crosshair,
  Zap,
  Target,
  Trophy,
  Calendar,
  Quote,
  Instagram,
  Mail,
  ChevronDown,
} from "lucide-react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Products from "@/components/landing/Products";
import Stats from "@/components/landing/Stats";
import Marks from "@/components/landing/Marks";
import Stickers from "@/components/landing/Stickers";
import Schedule from "@/components/landing/Schedule";
import Testimonials from "@/components/landing/Testimonials";
import Reserve from "@/components/landing/Reserve";
import Footer from "@/components/landing/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Landing() {
  // Reveal-on-scroll handler
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const reserveRef = useRef(null);
  const scrollToReserve = () => {
    reserveRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleReserve = async (payload) => {
    try {
      const res = await axios.post(`${API}/reservations`, payload);
      toast.success("YOU'RE ON THE LIST.", {
        description: `Reserved ${payload.size} for ${payload.name}. We'll be in touch.`,
      });
      return res.data;
    } catch (err) {
      toast.error("Something went sideways.", {
        description: "Try again in a sec.",
      });
      throw err;
    }
  };

  return (
    <main className="bg-[#0a0a0a] text-white min-h-screen relative overflow-hidden">
      <Nav onCta={scrollToReserve} />
      <Hero onCta={scrollToReserve} />
      <Marquee />
      <Stats />
      <Products onCta={scrollToReserve} />
      <Marks />
      <Stickers />
      <Manifesto />
      <Schedule />
      <Testimonials />
      <Reserve ref={reserveRef} onSubmit={handleReserve} />
      <Footer />
    </main>
  );
}
